'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require('semantic-ui-react');

var _formatting = require('./../../utils/formatting');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _notAvailableComponent = require('../not-available-component');

var _notAvailableComponent2 = _interopRequireDefault(_notAvailableComponent);

var _privateDataComponent = require('../private-data-component');

var _privateDataComponent2 = _interopRequireDefault(_privateDataComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var METRIC_NAME = 'shares';
var SHARE_INDEX = 7; // shares is indexed 7 in the YT data

var SharesComponent = function SharesComponent(_ref) {
  var post = _ref.post,
      inGIMode = _ref.inGIMode;

  var _ref2 = post.latestStatistic || {},
      insights = _ref2.insights;

  var _ref3 = post.trackedAsset || {},
      platform = _ref3.platform,
      supportingData = _ref3.supportingData,
      assetType = _ref3.assetType;

  if (platform === 'YOUTUBE' && insights) {
    var shareCount = _lodash2.default.sumBy(insights.viewingByCountry, function (o) {
      return o[SHARE_INDEX];
    });
    return _react2.default.createElement(
      'span',
      null,
      (0, _formatting.sciFormatted)(shareCount)
    );
  }

  if (platform === 'YOUTUBE') {
    return _react2.default.createElement(_privateDataComponent2.default, { post: post });
  }

  // TODO - figure this out as well.
  if (platform === 'FACEBOOK') {
    if (post.postType === 'post') {
      return _react2.default.createElement(
        'span',
        null,
        (0, _formatting.sciFormatted)(post.latestStatistic.shareCount)
      );
    }

    return _react2.default.createElement(_notAvailableComponent2.default, { platform: platform, metricName: METRIC_NAME, assetType: 'video' });
  }

  if ((_lodash2.default.isEqual(_lodash2.default.get(post, 'type'), 'stories') || platform === 'INSTAGRAM') && inGIMode) {
    if (post.finalClicks) {
      return post.finalClicks;
    }
    if (post.type === 'stories') {
      var _$get = _lodash2.default.get(post, 'relationships'),
          data = _$get.supportingData.data;

      var finalClicks = _lodash2.default.get(post, 'attributes.finalClicks');
      var _latestSupportingData = _lodash2.default.last(data) || {};
      return _react2.default.createElement(
        'span',
        null,
        inGIMode && finalClicks ? finalClicks : _lodash2.default.get(_latestSupportingData, 'attributes.clicks') || post.attributes.finalClicks || '-'
      );
    }
    if (post.trackedAsset) {
      var iGSupportingData = post.trackedAsset.iGSupportingData;

      if (iGSupportingData) {
        var filtered = _lodash2.default.filter(iGSupportingData, 'createdDate'); // remove the GraphQL null at [0]
        var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
          return o.createdDate;
        }));
        var _latestSupportingData2 = ordered[0];
        return _react2.default.createElement(
          'span',
          null,
          _latestSupportingData2 ? _latestSupportingData2.clicks : '-'
        );
      }
    }
    return _react2.default.createElement(
      'span',
      null,
      '-'
    );
  }

  if (platform === 'INSTAGRAM' && assetType === 'STORY') {
    return _react2.default.createElement(_notAvailableComponent2.default, { platform: platform, metricName: METRIC_NAME, assetType: 'story' });
  }

  if (platform === 'INSTAGRAM') {
    return _react2.default.createElement(_notAvailableComponent2.default, { platform: platform, metricName: METRIC_NAME, assetType: 'post' });
  }

  var latestSupportingData = void 0;

  if (supportingData && supportingData.length) {
    console.log(supportingData);
    var _filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
    var _ordered = _lodash2.default.reverse(_lodash2.default.sortBy(_filtered, function (o) {
      return o.createdDate;
    }));
    latestSupportingData = _ordered[0];
  }

  if (latestSupportingData) {
    return _react2.default.createElement(
      'span',
      null,
      (0, _formatting.sciFormatted)(latestSupportingData.impressions)
    );
  }

  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle outline', color: 'grey' });
};

exports.default = SharesComponent;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/shares-component/index.js
 ** module id = 2624
 ** module chunks = 0
 **/